import { BaseService } from './BaseService';

export class PaymentProvidersService extends BaseService {

  async getProviders(){
    try {
      return this.http('app/payment-provicers', 'get', {});
    } catch (error) {
      return {
        ok: false,
        message: error.message
      }
    }
  }
  async addProvider(name, client, account_number){
    const response = {
      ok: false,
      message: ''
    };
    try {
      return this.httpPost('app/payment-provicers', {
        name,
        client,
        account_number
      });
    } catch (error) {
      response.message = error.message;
      response.ok = false;
    }
    return response;
  }
  
  async editProvider(id, name, client, account_number){
    const response = {
      ok: false,
      message: ''
    };
    try {
      return this.http(`app/payment-provicers/${id}`, 'put', {
        name,
        client,
        account_number
      });
    } catch (error) {
      response.message = error.message;
      response.ok = false;
    }
    return response;
  }
  
  async deleteProvider(id){
    const response = {
      ok: false,
      message: ''
    };
    try {
      return this.http(`app/payment-provicers/${id}`, 'delete', {});
    } catch (error) {
      response.message = error.message;
      response.ok = false;
    }
    return response;
  }

}